<template>
  <LmDialog v-model="modalShow" :title="modalTitle || ''" :styles="{ minWidth: '900px' }">
    <template #toolbar-actions>
      <q-btn :disable="created" size="sm" label="Save" color="tertiary" @click="process" />
    </template>
    <template #content>
      <q-card-section>
        <div class="row">
          <q-editor
            ref="editor"
            v-model="formData.body"
            :content-style="{ listStylePosition: 'inside' }"
            :fonts="Q_EDITOR_MIXIN_fonts"
            :toolbar="Q_EDITOR_MIXIN_toolbarSettings"
            style="width: 100%"
            class="col-xs-12"
            toolbar-toggle-color="yellow-8"
            toolbar-flat
            @paste.native="Q_EDITOR_MIXIN_onPaste"
          />
        </div>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep, get } from 'lodash'
import { placeCaretAtEnd } from '@/lib/generic.utils'
import Q_EDITOR_MIXIN from '@/mixins/q-editor-mixin'
import { stripHtmlFromInput } from '@lib/formatting.utils'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'FormCreateNote',
  components: {
    LmDialog
  },
  inject: ['service'],
  mixins: [Q_EDITOR_MIXIN],
  props: {
    showing: {
      type: Boolean,
      default: false
    },
    namespace: {
      type: String,
      required: true
    },
    editable: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
      formData: null,
      dataTemplate: {
        body: ''
      },
      created: false
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    },
    modalTitle() {
      if (!this.modalShow) return
      if (!this.editable) return 'Create note'
      return 'Edit note'
    }
  },
  watch: {
    editable(newVal) {
      let formData = newVal ? new LmFormObject(newVal) : new LmFormObject(this.dataTemplate)
      this.$set(this, 'formData', formData)
    },
    modalShow(val) {
      val && this.focusInEditor()
    }
  },
  created() {
    this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
  },
  methods: {
    process() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      data.body = stripHtmlFromInput(this.formData.body)
      let params = {
        namespace: this.namespace,
        value: data
      }
      if (data.id) {
        params.id = data.id
      }
      let action = this.editable ? `update` : `create`
      this.service[action](params)
        .then(({ data }) => {
          if (!get(data, 'messages.errors')) {
            this.$emit('refresh', data.result)
            this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
            this.closeModal()
          } else {
            this.created = false
          }
        })
        .catch(() => {
          this.created = false
        })
    },
    closeModal() {
      this.$emit('close')
      this.created = false
      this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
    },
    focusInEditor() {
      setTimeout(() => {
        placeCaretAtEnd(this.$refs.editor.caret.el)
      }, 1)
    }
  }
}
</script>
